<template>
    <div class="page">
        <div class="page_content">
            <div class="top">
               <div class="top_title">{{text.title[lang]}}</div>
            </div>
            <div class="middle" id="middle1">
                <div class="middle1_bg" id="middle1_bg">
                    <img class="img_base" src="../assets/images/tiger2.jpg" alt="">
                    <div class="mask" id="middle1_content"></div>
                    <div class="middle1_title">{{text.midpart1.title[lang]}}</div>
                </div>
                <div class="middle1_content">
                    <div class="words" id="mid1_words">
                        <div :class="'word_item mid1_word_' + (index + 1)" v-for="(item, index) in text.midpart1.words" :key="index">{{item.title[lang]}}</div>
                    </div>
                    <div class="articles">
                        <div :class="{'article_item': true, 'article_line': index < text.midpart1.articles.length - 1}" v-for="(item, index) in text.midpart1.articles" :key="index">
                            <div class="article_from">{{item.from[lang]}}</div>
                            <a :href="item.url" class="article_title" target='_blank'>
                                {{item.title[lang]}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="middle2" id="middle2">
                <img class="img_base" src="../assets/images/weilidai.jpg" alt="">
                <div class="words" id="mid1_words">
                    <div :class="'word_item mid2_word_' + (index + 1)" v-for="(item, index) in text.midpart2.words" :key="index">{{item.title[lang]}}</div>
                </div>
                <div class="middle2_title">{{text.midpart2.title[lang]}}</div>
                <div class="articles2">
                    <div :class="{'article_item': true, 'article_line': index < text.midpart2.articles.length - 1}" v-for="(item, index) in text.midpart2.articles" :key="index">
                        <div class="article_from">{{item.from[lang]}}</div>
                        <a :href="item.url" class="article_title" target='_blank'>
                            {{item.title[lang]}}
                        </a>
                    </div>
                </div>
            </div>
            <div class="middle" id="middle3">
                <div class="middle1_bg" id="middle3_bg">
                    <img class="img_base" src="../assets/images/elephant.jpg" alt="">
                    <div class="mask" id="middle3_content"></div>
                    <div class="middle1_title">{{text.midpart3.title[lang]}}</div>
                </div>
                <div class="middle1_content">
                    <div class="words" id="mid3_words">
                        <div :class="'word_item mid1_word_' + (index + 1)" v-for="(item, index) in text.midpart3.words" :key="index">{{item.title[lang]}}</div>
                    </div>
                    <div class="articles">
                        <div :class="{'article_item': true, 'article_line': index < text.midpart3.articles.length - 1}" v-for="(item, index) in text.midpart3.articles" :key="index">
                            <div class="article_from">{{item.from[lang]}}</div>
                            <a :href="item.url" class="article_title" target='_blank'>
                                {{item.title[lang]}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <dir class="middle4" id="middle4">
                <div class="middle4_title">{{text.midpart4.title[lang]}}</div>
                <div class="middle4_content">{{text.midpart4.content[lang]}}</div>
            </dir>
        </div>
        <Foot/>
        <Nav></Nav>
    </div>
</template>

<script>
import {socialText} from '@/js/text.js'
import {wxShare} from '@/js/api.js'
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
export default {
    components: {
        Nav,
        Foot
    },
    data () {
        return {
            text: socialText
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        }
    },
    methods: {
        htmlTopPosition (obj) {
            var o = obj
            var t = o.offsetTop
            while (o.offsetParent) {
                o = o.offsetParent
                t += o.offsetTop
            }
            return t
        },
        onPageScroll () {
            if (!this.middle1 || !this.middle1_top || !this.middle2 || !this.middle3 || !this.middle3_top || !this.middle4 || !this.viewHeight || !this.words1 || !this.words3) return
            var top = document.body.scrollTop || document.documentElement.scrollTop
            if (top < this.middle1_top) {
                this.middle1_bg.style.position = 'absolute'
                this.middle1_bg.style.top = 0
                this.middle1_bg.style.transform = 'translateY(0)'
            } else if (this.middle2.getBoundingClientRect().top > this.viewHeight) {
                this.middle1_bg.style.position = 'fixed'
                this.middle1_bg.style.top = 0
                this.middle1_bg.style.transform = 'translateY(0)'
            } else {
                this.middle1_bg.style.position = 'absolute'
                this.middle1_bg.style.top = '100%'
                this.middle1_bg.style.transform = 'translateY(-100%)'
                if (top < this.middle3_top) {
                    this.middle3_bg.style.position = 'absolute'
                    this.middle3_bg.style.top = 0
                    this.middle3_bg.style.transform = 'translateY(0)'
                } else if (this.middle4.getBoundingClientRect().top > this.viewHeight) {
                    this.middle3_bg.style.position = 'fixed'
                    this.middle3_bg.style.top = 0
                    this.middle3_bg.style.transform = 'translateY(0)'
                } else {
                    this.middle3_bg.style.position = 'absolute'
                    this.middle3_bg.style.top = '100%'
                    this.middle3_bg.style.transform = 'translateY(-100%)'
                }
            }
            if (top > this.middle1_top + 0.1 * this.viewHeight) {
                this.words1.style.opacity = 0
                this.middle1_content.style.background = 'rgba(0, 0, 0, 0.4)'
            } else {
                this.words1.style.opacity = 1
                this.middle1_content.style.background = 'transparent'
            }
            if (top > this.middle3_top + 0.1 * this.viewHeight) {
                this.middle3_content.style.background = 'rgba(0, 0, 0, 0.4)'
                this.words3.style.opacity = 0
            } else {
                this.words3.style.opacity = 1
                this.middle3_content.style.background = 'transparent'
            }
        },
        onPageResize () {
            this.middle1_top = this.htmlTopPosition(this.middle1)
            this.middle3_top = this.htmlTopPosition(this.middle3)
            this.viewHeight =  document.documentElement.clientHeight
            this.onPageScroll()
        }
    },
    mounted () {
        this.middle1 = document.getElementById('middle1')
        this.middle1_bg = document.getElementById('middle1_bg')
        this.middle1_top = this.htmlTopPosition(this.middle1)
        this.middle1_content = document.getElementById('middle1_content')
        this.middle2 = document.getElementById('middle2')
        this.middle3 = document.getElementById('middle3')
        this.middle3_bg = document.getElementById('middle3_bg')
        this.middle3_top = this.htmlTopPosition(this.middle3)
        this.middle3_content = document.getElementById('middle3_content')
        this.middle4 = document.getElementById('middle4')
        this.words1 = document.getElementById('mid1_words')
        this.words3 = document.getElementById('mid3_words')
        this.viewHeight =  document.documentElement.clientHeight
        window.onscroll = this.onPageScroll
        window.onresize = this.onPageResize
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '关于我们-社会责任'])
        const url = location.href
        var shareInfo = {
            title: '为客户提供增长落地方案',
            desc: 'Deansel专注于解决客户在新生态下的增长方案'
        }
        wxShare(url, shareInfo)
    }
}
</script>

<style scoped>
.top {
    width: 100%;
    height: 100vh;
    background: linear-gradient(0.005turn, #7291BB, #1B2243);
    position: relative;
    text-align: center;
}
.top_title {
    width: 60%;
    position: absolute;
    top: 45%;
    left: 20%;
    transform: translateY(-50%);
    font-size: 2.75rem;
    font-weight: 500;
    line-height: 1.5;
    color: #fff;
}
.middle {
    width: 100vw;
    min-height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
}
.middle1_bg {
    width: 100vw;
    height: 100vh;
    background: #47538D;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.mask {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.middle1_content {
    width: 100%;
    position: relative;
    z-index: 2;
}
.words {
    /* position: absolute; */
    transition: all 0.4s ease;
    opacity: 1;
}
.word_item {
    position: absolute;
    font-size: 1.875rem;
    background: #fff;
    height: 2.5rem;
    line-height: 2.5rem;
    padding: 0 0.5rem;
    box-shadow: 0 4px 4px #4E64BC;
}
.mid1_word_1 {
    top: 15%;
    left: 10%;
}
.mid1_word_2 {
    top: 5%;
    left: 45%;
}
.mid1_word_3 {
    top: 26%;
    right: 5%;
}
.mid1_word_4 {
    top: 48%;
    left: 28%;
}
.mid2_word_1 {
    top: 20%;
    left: 10%;
}
.mid2_word_2 {
    top: 8%;
    left: 35%;
}
.mid2_word_3 {
    top: 42%;
    right: 5%;
}
.mid2_word_4 {
    top: 25%;
    left: 68%;
}
.middle1_title {
    width: 80%;
    text-align: center;
    position: absolute;
    left: 10%;
    top: 50vh;
    transform: translateY(-50%);
    font-size: 3.125rem;
    color: #fff;
    font-weight: 500;
    z-index: 1;
}
.articles {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 120vh;
    margin-bottom: 5%;
    color: #fff;
}
.articles2 {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 5vw;
    color: #fff;
}
.article_item {
    flex: 1;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    text-align: left;
    line-height: 1.5;
}
.article_from {
    width: 70%;
    font-size: 0.875rem;
    margin-top: 10%;
    margin-bottom: 10px;
}
.article_title {
    color:#fff;
    text-decoration: none;
    width: 70%;
    height: 3.375rem;
    font-size: 1.125rem;
    font-weight: bold;
    margin-bottom: 10%;
    text-decoration: none;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.article_title:hover {
    text-decoration: underline;
}
.article_line {
    border-right: 1px solid #d5d5d5;
}
.middle2 {
    width: 100vw;
    height: 100vh;
    position: relative;
}
.middle2_title {
    width: 80%;
    text-align: center;
    position: absolute;
    left: 10%;
    top: 50%;
    transform: translateY(-50%);
    font-size: 3.125rem;
    font-weight: 500;
    color: #fff;
}
.middle4 {
    margin: 0 10% 10% 10%;
    padding: 10% 0 0 0;
    width: 80%;
    box-sizing: border-box;
}
.middle4_title {
    width: 100%;
    text-align: center;
    font-size: 2.25rem;
    font-weight: 400;
    margin-bottom: 5%;
}
.middle4_content {
    width: 100%;
    text-align: left;
    font-size: 0.875rem;
}
@media screen and (max-width: 756px){
    .mid1_word_2 {
        left: auto;
        right: 5%;
    } 
    .mid1_word_4 {
        left: auto;
        right: 10%;
    }
    .mid2_word_3 {
        top: 70%;
    }
}
</style>
